import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Client } from 'src/app/models/client';
import { AuthService } from 'src/app/services/auth.service';
import { generateUuidV4 } from 'src/app/utils/uuid-utils';

@Component({
  selector: 'app-setup-income-stacks',
  templateUrl: './setup-income-stacks.component.html',
  styleUrls: ['./setup-income-stacks.component.scss'],
})
export class SetupIncomeStacksComponent implements OnInit {
  @Input() client!: Client;

  startDate?: Date;
  todayDate = new Date();

  addStackVisible = false;
  isAddingStack = false;
  isEdittingStack = false;
  stackId?: string;
  stackTitle = '';
  stackType = 'PPL';
  stackAmount = '';
  stackPaymentType = 'PAYMENT';
  stackPayment = '';
  stackLoanConstant = '';
  stackFrequency = '1';
  stackFrequencyUnits = 'months';
  stackPayments = 36;

  formatterDollar = (value: number) => `$ ${value}`;
  parserDollar = (value: string) => value.replace('$ ', '');
  formatterPercent = (value: number) => `${value} %`;
  parserPercent = (value: string) => value.replace(' %', '');

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService
  ) {}

  ngOnInit(): void {}

  addStack() {
    if (!this.isEdittingStack) {
      this.isAddingStack = true;
      this.addStackVisible = true;
    }
  }

  editStack(stack: any) {
    if (!this.isAddingStack) {
      this.isEdittingStack = true;
      this.stackId = stack.id;
      this.stackTitle = stack.title;
      this.stackType = stack.type;
      this.stackAmount = stack.amount;
      this.stackPayment = stack.payment;
      this.stackLoanConstant = stack.loanConstant;
      this.stackPayments = stack.payments;
      this.addStackVisible = true;
    }
  }

  cancelAddStack() {
    this.addStackVisible = false;
    this.isAddingStack = false;
    this.isEdittingStack = false;
  }

  okAddStack() {
    if (this.isAddingStack) {
      this.addStackVisible = false;
      this.isAddingStack = false;
      let stack = {
        id: generateUuidV4(),
        title: this.stackTitle,
        type: this.stackType,
        amount: this.stackAmount,
        paymentType: this.stackPaymentType,
        payment: this.stackPayment,
        loanConstant: this.stackLoanConstant,
        frequency: this.stackFrequency,
        frequencyUnits: this.stackFrequencyUnits,
        payments: this.stackPayments,
      };
      this.httpClient
        .post('/api/clients/' + this.client!.id + '/incomestacks', stack, {
          headers: new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('X-Access-Token', `Bearer ${this.authService.token}`),
        })
        .subscribe((result: any) => {
          if (result.result == 0) {
            //this.clearPlanOptimization();

            if (!this.client!.incomeStacks) {
              this.client!.incomeStacks = [];
            }
            this.client!.incomeStacks.push(result.stack);
          }
        });
    } else if (this.isEdittingStack) {
      this.addStackVisible = false;
      this.isEdittingStack = false;
      let stack = {
        id: this.stackId,
        title: this.stackTitle,
        type: this.stackType,
        amount: this.stackAmount,
        paymentType: this.stackPaymentType,
        payment: this.stackPayment,
        loanConstant: this.stackLoanConstant,
        frequency: this.stackFrequency,
        frequencyUnits: this.stackFrequencyUnits,
        payments: this.stackPayments,
      };
      this.httpClient
        .post(
          '/api/clients/' + this.client!.id + '/incomestacks/' + stack.id,
          stack,
          {
            headers: new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('X-Access-Token', `Bearer ${this.authService.token}`),
          }
        )
        .subscribe((result: any) => {
          if (result.result == 0) {
            //this.clearPlanOptimization();

            let found = -1;
            let index = 0;
            for (let s of this.client!.incomeStacks!) {
              if (s.id && s.id === stack.id) {
                found = index;
              }
              index++;
            }
            if (found !== -1) {
              this.client!.incomeStacks!.splice(found, 1, stack);
            }
          }
        });
    }
  }

  deleteStack() {
    if (this.isEdittingStack) {
      this.addStackVisible = false;
      this.isEdittingStack = false;
      this.httpClient
        .delete(
          '/api/clients/' + this.client!.id + '/incomestacks/' + this.stackId,
          {
            headers: new HttpHeaders()
              .set('Content-Type', 'application/json')
              .set('X-Access-Token', `Bearer ${this.authService.token}`),
          }
        )
        .subscribe((result: any) => {
          if (result.result == 0) {
            //this.clearPlanOptimization();

            let found = -1;
            let index = 0;
            for (let s of this.client!.incomeStacks!) {
              if (s.id && s.id === this.stackId) {
                found = index;
              }
              index++;
            }
            if (found !== -1) {
              this.client!.loans!.splice(found, 1);
            }
          }
        });
    }
  }

  updateStackPayment() {
    if (this.stackPaymentType == 'PAYMENT') {
      this.calculateLoanConstant();
    }
  }

  updateStackLoanConstant() {
    if (this.stackPaymentType == 'LOAN_CONSTANT') {
      this.calculatePayment();
    }
  }

  updateFrequency() {
    if (this.stackPaymentType == 'PAYMENT') {
      this.calculateLoanConstant();
    }
    if (this.stackPaymentType == 'LOAN_CONSTANT') {
      this.calculatePayment();
    }
  }

  getFrequencyInMonths() {
    if (this.stackFrequency == '') {
      return 1;
    }
    if (this.stackFrequencyUnits == 'years') {
      return +this.stackFrequency * 12;
    }

    return +this.stackFrequency;
  }

  calculateLoanConstant() {
    console.log('Frequency in months is ' + this.getFrequencyInMonths());
    this.stackLoanConstant =
      '' +
      (+this.stackPayment / this.getFrequencyInMonths() / +this.stackAmount) *
        100;
  }

  calculatePayment() {
    console.log('Frequency in months is ' + this.getFrequencyInMonths());
    this.stackPayment =
      '' +
      this.getFrequencyInMonths() *
        (+this.stackLoanConstant / 100) *
        +this.stackAmount;
  }

  clearPlanOptimization() {
    if (this.client!.plan) {
      this.client!.plan!.optimizer = undefined;
      this.client!.plan!.optimizerLevel = undefined;
    }
    if (this.client!.jobs) {
      for (let job of this.client!.jobs) {
        job.outOfDate = true;
      }
    }
  }

  get stackFrequencyYearsLabel() {
    return +this.stackFrequency > 1 ? 'Years' : 'Year';
  }
  get stackFrequencyMonthsLabel() {
    return +this.stackFrequency > 1 ? 'Months' : 'Month';
  }
  get stackFrequencyGreaterThanZero() {
    return +this.stackFrequency > 0;
  }
}
